export type OverviewPreviewPageBlock =
  | 'summary'
  | 'channels'
  | 'best_content'
  | 'activity';

export interface OverviewReportPreviewPageModel {
  blocks: OverviewPreviewPageBlock[];
}

export function buildOverviewReportPreviewPages(
  isGroupSelected: boolean,
): OverviewReportPreviewPageModel[] {
  if (isGroupSelected) {
    return [
      { blocks: ['summary', 'channels'] },
      { blocks: ['best_content', 'activity'] },
    ];
  }

  return [{ blocks: ['summary', 'best_content', 'activity'] }];
}

export function countOverviewReportPreviewPages(
  isGroupSelected: boolean,
): number {
  return buildOverviewReportPreviewPages(isGroupSelected).length;
}
